import React from "react";
import { whyChooseUs } from "../mock";
import { Award, Truck, Recycle, ShieldCheck, Headphones } from "lucide-react";

const iconMap = { Award, Truck, Recycle, ShieldCheck, Headphones };

const WhyChoose = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="font-display text-center text-4xl md:text-5xl font-bold">
          WHY <span className="text-[color:var(--brand-red)]">CHOOSE ERM</span>
        </h2>
        <div className="h-1 w-20 bg-[color:var(--brand-red)] mx-auto mt-4 mb-14" />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {whyChooseUs.map((item, i) => {
            const Icon = iconMap[item.icon];
            return (
              <div
                key={i}
                className="why-card bg-white border-2 border-[color:var(--brand-teal)]/30 rounded-md p-6 text-center"
              >
                <div className="w-16 h-16 mx-auto rounded-full bg-[color:var(--brand-red)]/10 flex items-center justify-center border border-[color:var(--brand-red)]/30">
                  <Icon size={30} className="text-[color:var(--brand-red)]" />
                </div>
                <h3 className="font-display font-bold text-lg mt-5">{item.title}</h3>
                <p className="text-sm text-gray-600 mt-3 leading-relaxed">{item.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
